import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as Actions from '../../store/actions';
import { Text, View } from '@aws-amplify/ui-react';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { Images } from '../index';
import './style.sass';
import { useNavigate } from 'react-router-dom';
import * as TYPES from '../../store/actions/actions';
import { toast } from 'react-toastify';

const StartTestRow = ({
  quizId,
  testType,
  testTime,
  testUnit,
  testTitle,
  testDescription,
  selectedQuiz,
  selectedSectionId,
  userQuizScore,
  selectedSection,
  index,
}) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [isAnyStarted, setIsAnyStarted] = useState(false);
  useEffect(() => {
    if (userQuizScore?.sections) {
      userQuizScore?.sections.map((section) => {
        if (section?.status === 'STARTED') {
          setIsAnyStarted(true);
        }
      });
    }
  }, [userQuizScore]);
  return (
    <div className={'start-test-row'}>
      <div className={'card-row'}>
        <div className={'card-col-2'}>
          <div className={'test-time-div'}>
            <View className={'test-time'}>
              <Text>{testTime}</Text>
              <Text style={{ marginTop: '-6px' }}>{testUnit}</Text>
            </View>
          </div>
          <View>
            <Text className={'test-name'}>{testTitle}</Text>
            <Text className={'test-description'}>{testDescription}</Text>
          </View>
        </div>

        {testType == 'new' ? (
          <div className={'card-col'}>
            <View
              className={'menu start-test'}
              onClick={() => {
                if (selectedSection?.status === 'FINISHED') {
                  return toast.error('This section has been completed.');
                }
                if (index > 0) {
                  if (userQuizScore?.sections[index - 1]?.status !== 'FINISHED') {
                    return toast.error('Please complete previous section first.');
                  }
                }
                dispatch({
                  type: TYPES.UI_START_LOADING,
                });
                dispatch(Actions.saveFinishedQuizId(quizId));
                dispatch(Actions.saveCurrentSectionId(selectedSectionId));
                dispatch(Actions.saveCurrentSection(selectedSection));
                if (selectedSection?.status === 'PENDING') {
                  var updateUserQuizSection = {
                    id: selectedSectionId,
                    quizId: userQuizScore?.quizId,
                    userQuizId: userQuizScore?.id,
                    userId: userQuizScore?.userId,
                    status: 'STARTED',
                  };
                  dispatch({
                    type: TYPES.UI_START_LOADING,
                  });
                  dispatch(Actions.dispatchUpdateUserQuizSection(updateUserQuizSection)).then(
                    (res1) => {
                      if (selectedQuiz?.status == 'PENDING') {
                        var userData = {
                          id: selectedQuiz.id,
                          userId: selectedQuiz.userId,
                          status: 'STARTED',
                        };
                        dispatch({
                          type: TYPES.UI_START_LOADING,
                        });
                        dispatch(Actions.dispatchUpdateUserQuiz(userData)).then((res2) => {
                          if (selectedSection?.status !== 'FINISHED') {
                            navigate('/new_quiz');
                          }
                        });
                      } else if (selectedSection?.status !== 'FINISHED') {
                        navigate('/new_quiz');
                      }
                    },
                  );
                } else if (selectedSection?.status !== 'FINISHED') {
                  navigate('/new_quiz');
                }
              }}
            >
              {selectedSection?.status == 'PENDING' ||
              selectedSection?.status == 'STARTED' ||
              selectedSection?.status === 'EXPIRED' ? (
                <>
                  {index === 0 ? (
                    <>
                      <Text className={selectedSection?.status === 'PENDING' ? '' : 'text-warning'}>
                        <AiOutlineArrowRight />
                      </Text>
                      <Text
                        className={
                          selectedSection?.status === 'PENDING'
                            ? 'text-700'
                            : 'text-warning text-700'
                        }
                      >
                        {selectedSection?.status === 'PENDING' ||
                        selectedSection?.status === 'EXPIRED'
                          ? 'Start'
                          : 'Continue'}
                      </Text>
                    </>
                  ) : (
                    <>
                      <Text
                        className={
                          selectedSection?.status === 'STARTED'
                            ? 'text-warning text-700'
                            : selectedSection?.status === 'PENDING' &&
                              userQuizScore?.sections[index - 1]?.status === 'FINISHED'
                            ? ''
                            : 'text-muted text-700'
                        }
                      >
                        <AiOutlineArrowRight />
                      </Text>
                      <Text
                        className={
                          selectedSection?.status === 'STARTED'
                            ? 'text-warning text-700'
                            : selectedSection?.status === 'PENDING' &&
                              userQuizScore?.sections[index - 1]?.status === 'FINISHED'
                            ? 'text-700'
                            : 'text-muted text-700'
                        }
                      >
                        {selectedSection?.status === 'STARTED' ||
                        selectedSection?.status === 'EXPIRED'
                          ? 'Continue'
                          : selectedSection?.status === 'PENDING' &&
                            userQuizScore?.sections[index - 1]?.status === 'FINISHED'
                          ? 'Start'
                          : 'Next'}
                      </Text>
                    </>
                  )}
                </>
              ) : null}

              {selectedSection?.status == 'FINISHED' ? (
                <>
                  {/* <Text>
                    <AiOutlineArrowRight />
                  </Text> */}
                  <Text className="text-info text-700">Done</Text>
                </>
              ) : null}
            </View>
            {/* <View className={"menu reset-test"}>
                            <Text><img src={Images.reset}/></Text>
                            <Text>Reset</Text>
                        </View> */}
          </div>
        ) : (
          <div className={'card-col'}>
            <View className={'menu view-result'}>
              <Text>
                <AiOutlineArrowRight />
              </Text>
              <Text>View Results</Text>
            </View>
            <View className={'menu show-paper'}>
              <Text>
                <img src={Images.paper} />
              </Text>
              <Text>Score Paper</Text>
            </View>
          </div>
        )}
      </div>
    </div>
  );
};

export default StartTestRow;
